import React, { useEffect, useState } from 'react';
import api from "../../utils/axiosInstance";
import AdminSideMenu from '../../components/AdminSideMenu';

const ResumePendingApproval = () => {
    const [resumes, setResumes] = useState([]);
    const [modal, setModal] = useState({ show: false, title: '', id: null });
    const [selectedResume, setSelectedResume] = useState(null);

    const fetchPendingResumes = async () => {
        try {
            const res = await api.get('/resumes/pending');
            setResumes(res.data || []);
        } catch (err) {
            console.error('Failed to fetch:', err);
        }
    };


    useEffect(() => {
        fetchPendingResumes();
    }, []);

    const showModal = (title, id) => {
        setModal({ show: true, title, id });
    };

    const hideModal = () => {
        setModal({ show: false, title: '', id: null });
    };

    const confirmAction = async () => {
        try {
            if (modal.title.includes('Approve')) {
                await api.post(`/resumes/approve/${modal.id}`);
            } else {
                await api.delete(`/resumes/pending/${modal.id}`);
            }
            hideModal();
            fetchPendingResumes();
        } catch (err) {
            console.error('Action failed:', err);
        }
    };

    return (
        <div className="flex flex-col md:flex-row min-h-screen bg-gray-50">
            <AdminSideMenu />
            <div className="w-full md:ml-64 p-4 sm:p-6 lg:p-8">
                <header className="pb-4">
                    <h1 className="text-3xl font-bold text-gray-900">Pending Resumes</h1>
                    <p className="text-gray-600">Review and Approve Driver Resumes</p>
                </header>

                <section className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
                    {resumes.length === 0 ? (
                        <div className="col-span-full text-center text-gray-500 text-lg py-12">
                            No resumes pending for approval.
                        </div>
                    ) : (
                        resumes.map((resume) => (
                            <div
                                key={resume._id}
                                className="bg-white p-6 rounded-xl shadow-sm border border-blue-600 border-l-4 hover:scale-[1.02] hover:shadow-md transition relative"
                            >

                                <div className="mb-3">
                                    <h3 className="text-lg font-semibold text-gray-900">{resume.driverName}</h3>
                                </div>

                                <div className="space-y-1 text-sm text-gray-600">
                                    <p><span className="font-semibold">Uploaded Resume:</span></p>
                                    <a
                                        href={`${process.env.REACT_APP_IMAGE_BASE_URL}/${resume.filePath?.replace(/\\/g, '/')}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-blue-500 underline text-sm"
                                    >
                                        View Resume
                                    </a>

                                </div>

                                <div className="mt-4 flex flex-wrap gap-2">
                                    <button
                                        onClick={() => showModal('Approve Resume', resume._id)}
                                        style={{ backgroundColor: '#888888', color: '#fff' }}
                                        className="inline-block px-4 py-2 rounded font-semibold"
                                    >
                                        Approve
                                    </button>

                                    <button
                                        onClick={() => showModal('Reject Resume', resume._id)}
                                        className="bg-blue-600 text-white px-4 py-2 rounded font-semibold"
                                    >
                                        Reject
                                    </button>
                                </div>
                            </div>
                        ))
                    )}
                </section>

                {/* Approve/Reject Modal */}
                {modal.show && (
                    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
                        <div className="bg-white rounded-xl shadow-lg p-8 max-w-sm w-full text-center">
                            <h3 className="text-xl font-bold text-gray-900 mb-6">{modal.title}</h3>
                            <div className="flex justify-center gap-4">
                                <button
                                    onClick={hideModal}
                                    style={{ backgroundColor: '#888888', color: '#fff' }}
                                    className="inline-block px-4 py-2 rounded font-semibold"
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={confirmAction}
                                    className="bg-blue-600 text-white px-5 py-2 rounded font-semibold"
                                >
                                    OK
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ResumePendingApproval;
